/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#detail-image[_ngcontent-%COMP%]   .closeIcon[_ngcontent-%COMP%]{position:absolute;top:5px;right:5px}#detail-image[_ngcontent-%COMP%]   .photodetail[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
